import axios from 'axios';

import { store , defineListControllers  } from "../state/redux";

export const  axios_email_searchbyid= async (id)=>{
    return  await axios({method:'POST',url :`/email/searchbyid`,data:{id}  ,headers:{'Accept':'application/json','Content-Type':'application/json'} });
}


export const  axios_email_experttrial = async ({lastname,firstname,nom_courtier})=>{
    return  await axios.post(  `/email/experttrial/`, {lastname,firstname,nom_courtier}, { headers: {"Content-Type": "multipart/form-data"} });
}

export const  axios_email_getclientemails= async (userpostmail,leadactuemail)=>{
    const controller = new AbortController();
    const actucontrollers = store.getState().formules.listcontrollers ;
    store.dispatch(defineListControllers([...actucontrollers,controller])) ;
    return  await axios.post(`/email/getclientemails`,{"emails" : [userpostmail,leadactuemail]}, {signal: controller.signal});  // , { headers: {'Accept':'application/json','Content-Type':'application/json'}}

}

export const  axios_email_getallemails= async (postmail)=>{
    return   await axios({method:'GET',url :`/email/getallemails`,data:{"postmail" : postmail}  ,headers:{'Accept':'application/json','Content-Type':'application/json'} });
}

export const  axios_email_getgestionmails= async ()=>{
    return  await  axios({method:'GET',url :`/email/getgestionmails`,headers:{ 'Accept': 'application/json', 'Content-Type': 'application/json'     } })
}

export const  axios_email_send= async (datasmessage)=>{
    return  await axios.post(  `/email/send/`, datasmessage, { headers: {"Content-Type": "multipart/form-data"}  });
}


export const  axios_email_transfer= async (message)=>{
    return  await axios.post(  `/email/transfer/`, message, { headers: {'Accept':'application/json','Content-Type':'application/json'} });
}


export const  axios_email_modifymailread= async (id)=>{
    return  await axios({method:'POST',url :`/email/modifymailread`,data:{id}  ,headers:{'Accept':'application/json','Content-Type':'application/json'} });
}

export const  axios_email_modifymailfavori= async ({id,favori})=>{
    return  await  axios({method:'POST',url :`/email/modifymailfavori`,data:{id,favori}  ,headers:{'Accept':'application/json','Content-Type':'application/json'} });
}

export const  axios_email_search= async (value,mailuser)=>{
    return  await axios.post(  `/email/search/`, {value,mailuser}, { headers: {'Accept':'application/json','Content-Type':'application/json'}  });
}




export const axios_email_postmarkmails = async ()=>{
        return  await axios.get(  `/email/postmarkoutbound/`, { headers: {'Accept':'application/json','Content-Type':'application/json'}  });
}


